<template>
    <layout name="LayoutDefault">
        <div class="About">
            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row">

                        <div class="col-lg-12 col-sm-12">

                            <div class="blog-post " v-for="item in dataRows">
                                <h2 class="blog-title">
                                    <a :href="`${baseUrl}press/${item.id}`">{{item.title}}</a>
                                </h2>

                                <div class="details">
                                    <span class="date">{{item.created_at}}</span>
                                </div>

                                <div class="blog-content mt-3 text-justify">
                                    <vue-load-image>
                                        <img slot="image" v-bind:src="`${IMAGEURL}${item.image}`" alt="" class="img-responsive blog-thumb-image"/>
                                        <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" title="Image Loading..."/>
                                        <div slot="error">can't load image</div>
                                    </vue-load-image>

                                    <div v-html="`${item.description.substr(0, 300)}`" class="blog-short-text"></div>

                                    <span v-if="item.id">...<a :href="`${baseUrl}press/${item.id}`" class="more-link">আরো দেখুন <i class="fa fa-chevron-right"></i></a></span>

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container -->
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Layout';
    import VueLoadImage from 'vue-load-image';

    export default {
        data() {
            return {
                dataRows: [
                    {
                        'image': 'Loading...',
                        'description': 'Loading...'
                    }
                ],
            }
        },
        components: {
            Layout,
            VueLoadImage
        },
        methods: {
            getData() {
                fetch(this.APIURL + 'cms-resources/Press')
                    .then(response => response.json())
                    .then(json => this.dataRows = json.data)
            }
        },
        mounted() {
            this.getData();
        }
    };
</script>
